import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=4c6a31c4&scoped=true&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=4c6a31c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a31c4",
  null
  
)

export default component.exports